import React from 'react'
import PropTypes from 'prop-types'
import { bem } from '@argos/utils'
import { Pill } from '@boltui/pills'

const cn = bem({ prefix: 'lc-', block: 'feedback-multiple-choice' })

const FeedbackMultipleChoice = ({ id, question, options, onSubmit }) => (
  <div className={`${cn()} lc-controls__form lc-controls__form--with-seperator`}>
    <span className='sr-only'>{question}</span>
    <div className={`${cn('question-text')}`}>{question}</div>
    <div className={cn('button-container')}>
      {options &&
        options.map((option, idx) => (
          <Pill
            key={`option-${idx}`}
            as='button'
            type='button'
            className={cn('option')}
            label={option.value}
            data-test={cn(`option-${idx}`)}
            onClick={() =>
              onSubmit({
                id,
                trackingCode: options[idx].pageValue,
                value: options[idx].value,
              })
            }
          />
        ))}
    </div>
  </div>
)

FeedbackMultipleChoice.propTypes = {
  id: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      pageValue: PropTypes.string,
    }),
  ),
  onSubmit: PropTypes.func,
  question: PropTypes.string,
}

export default FeedbackMultipleChoice
